import React, { useContext, useEffect, useState } from 'react';
import "../Styles/CloseStudyCss.css";
import { CloseStudyApi } from '../../../../service/StudyListService';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { useTranslation } from 'react-i18next';
import CloseStudyBody from './CloseStudyBody';
import ModalMain from '../../../../components/Modal/ModalMain';
import { CloseStudySchema, CloseStudySchemaWithReason } from './CloseStudySchema';
import { useFormik } from 'formik';
import studyReportContext from '../../../../context/studyreport/StudyReportContext';
import studylistContext from '../../../../context/studylist/StudylistContext';
import { MODAL_TYPE, TAB_NAME } from '../../../../constants/Constants';
import loaderContext from '../../../../context/loader/LoaderContext';

const CloseStudy = (props) => {

    const {setAlertSuccessModal,alertSuccessModal} = useContext(studyReportContext);
    const {setRefreshRequired,
            refreshRequired,
            dataQueryState,
            setDataQueryState,
    } = useContext(studylistContext);

    const { ref, setLoaderRunning, setShowModal,showModal } = useContext(loaderContext);

    const [t] = useTranslation();
    const reasonsList = [
        {key:"Not for reporting", text:t("close-study.no-need-report")},
        {key:"Double entry", text:t("close-study.double-entry")},
        {key:"Patient details not mentioned", text:t("close-study.patient-details-not-mentioned")},
        {key:"No images found",text:t("close-study.no-image-found")},
        {key:"Cannot open image", text:t("close-study.cannot-open")},
        {key:"Hospital asked not to report", text:t("close-study.not-to-report")},
        {key:"Incomplete images", text:t("close-study.incomplete-images")},
        {key:"Suboptimal Scan", text:t("close-study.suboptimal-scan")},
        {key:"Need second opinion", text:t("close-study.second-opinion")},
        {key:"Other", text:t("close-study.other")}
    ]

    const [isOtherReason, setIsOtherReason] = useState(false);

    const hideCloseStudyModal = () =>{
        console.log("cancel close study");
        props.setShowCloseStudyModal(false);
    }

    const { values, errors, handleChange, handleSubmit } =
    useFormik({
        initialValues: {
            reason:"select",
            otherReason:"",
            isOtherReason:false
        },
        validationSchema: isOtherReason ? CloseStudySchemaWithReason: CloseStudySchema,
        onSubmit: async () => {
            console.log("insubmit api call");
            if(values.reason === 'select'){
                setShowModal(()=>{
                    const newItem = {...showModal};
                    newItem.show = true;
                    newItem.type = MODAL_TYPE.ALERT_MODAL;
                    newItem.heading = "Alert";
                    newItem.isError = false;
                    newItem.isSuccess = false;
                    newItem.isWarning = true;
                    newItem.description = t("string-literals.no-values-selected");
                    return newItem;
                  });
                  return;
            }
            const data = {
                studyId:props.studyId,
                reasons: values.isOtherReason? values.otherReason: values.reason
            }
            setLoaderRunning(true);
            ref.current.continuousStart();
            const response = await CloseStudyApi(data, props.blitzSession);
            console.log(response);
            if (response.status === 200 && response.data.result === "SUCCESS") {
                props.setShowCloseStudyModal(false);

                if(props.blitzSession != null && props.blitzSession != undefined) {
                    console.log("Blitz session active ");
                    setLoaderRunning(false);  
                    ref.current.complete();
                    window.parent.goToNextStudy(false);
                } else {

                props.setShowCloseStudyReponseMsg(response.data.message);
                // props.setShowConfirmModal(true);
                setAlertSuccessModal(()=>{
                    const newItem = {...alertSuccessModal};
                    newItem.show = true;
                    newItem.heading = "Alert";
                    newItem.isError = false;
                    newItem.isSuccess = false;
                    newItem.isWarning = true;
                    newItem.description = response.data.message;
                    return newItem;
                  });

                  setTimeout(()=>{
                    setRefreshRequired(()=>{
                      const newItem = {...refreshRequired};
                      newItem[TAB_NAME.CLOSED].alreadyLoaded = false;
                      console.log(newItem);
                      return newItem;
                    });
                  },10);  
          
                  let newData = dataQueryState?.data?.rows.filter(
                    (row) => row.id !== props.studyId
                  );
                  setDataQueryState(() => {
                    const newValue = {
                      ...dataQueryState,
                    };
                    newValue.data.rows = newData;
                    return newValue;
                  });  
                  setLoaderRunning(false);  
                  ref.current.complete();
                }  

                //props.setShowCloseStudyResponseModal(true);
            } else {
                setLoaderRunning(false);  
                ref.current.complete();
                setAlertSuccessModal(()=>{
                    const newItem = {...alertSuccessModal};
                    newItem.show = true;
                    newItem.heading = "Error";
                    newItem.isError = false;
                    newItem.isSuccess = false;
                    newItem.isWarning = true;
                    newItem.description = t("string-literals.error-msg");
                    return newItem;
                  });
            }
        }
    });

    const handleChangeReason = (event, selected) =>{
        values.reason = selected.key;
        console.log(selected.key);
        if(selected.key===reasonsList[9].key){
            setIsOtherReason(true);
            values.isOtherReason = true;
        }
        else{
            setIsOtherReason(false);
            values.isOtherReason = false;
            values.otherReason = "";
        }
        console.log(values.isOtherReason,isOtherReason);
    }

    let PrimaryButtonList = [
        {
            title:t("button.yes"),
            onclick: handleSubmit
        }
    ]
    let DefaultButtonList = [
        {
            title:t("button.no"),
            onclick: hideCloseStudyModal
        }
    ];

    const modalDetails = {
        header: <ModalHeader updatedModal={true} patientName={props.patientName} patientId={props.patientId} heading={t("close-study.title")} handleCancel={hideCloseStudyModal}/>,
        body: <CloseStudyBody values={values} errors={errors} reasonsList={reasonsList} handleChange={handleChange} handleChangeReason={handleChangeReason} isOtherReason={isOtherReason}/>,
        footer: <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={PrimaryButtonList}/>,
        width: "400px"
    }
  return (
    <>
    
    {props.showCloseStudyModal && 
        <ModalMain updatedModal={true} showModal={props.showCloseStudyModal} modalDetails={modalDetails}/>
     }
     </>
  )
}

export default CloseStudy